import { render, staticRenderFns } from "./De.vue?vue&type=template&id=78baec84&scoped=true&"
var script = {}
import style0 from "./De.vue?vue&type=style&index=0&id=78baec84&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78baec84",
  null
  
)

export default component.exports